module.exports = __webpack_public_path__ + "img/spjk5.6f0e489d.png";